import { render } from "./appExamPaper.vue?vue&type=template&id=6555a4a9&scoped=true"
import script from "./appExamPaper.vue?vue&type=script&lang=js"
export * from "./appExamPaper.vue?vue&type=script&lang=js"

import "./appExamPaper.vue?vue&type=style&index=0&id=6555a4a9&lang=less&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6555a4a9"]])

export default __exports__